import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class StoresService {
  fetch(id, params) {
    return securedAxiosInstance.get(`/stores/${id}`, { params: toSnakeCase(params) });
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/stores", { params: toSnakeCase(params) });
  }

  updateGeneralInformations(storeId, data) {
    return securedAxiosInstance.put(
      `/store/${storeId}/configuration/update_general_informations`,
      toSnakeCase({ store: data }),
    );
  }

  updateContactInformations(storeId, data) {
    return securedAxiosInstance.put(
      `/store/${storeId}/configuration/update_contact_information`,
      toSnakeCase({ store: data }),
    );
  }

  updateAfterSalesService(storeId, data) {
    return securedAxiosInstance.put(
      `/store/${storeId}/configuration/update_after_sales_service`,
      toSnakeCase({ store: data }),
    );
  }

  configureStore(storeData) {
    return securedAxiosInstance.post("/stores/configure", toSnakeCase(storeData));
  }

  updateConfigurationStatus(storeId, step, status) {
    return securedAxiosInstance.put(`/stores/${storeId}/update_configuration_status`, { step, status });
  }

  updateStatus(storeId, status) {
    return securedAxiosInstance.put(`/stores/${storeId}/update_status`, { status });
  }

  updateChallenge(storeId, challengeId) {
    return securedAxiosInstance.put(`/stores/${storeId}/update_challenge`, { challenge_id: challengeId });
  }

  update(storeId, data) {
    return securedAxiosInstance.put(`/stores/${storeId}`, toSnakeCase(data));
  }

  updateDiscount(storeId, discountId) {
    return securedAxiosInstance.put(`/stores/${storeId}`, toSnakeCase({ id: storeId, discountId }));
  }
}

export default new StoresService();
